iScreenWizard.controller('P2CResultatenController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, p2cService, Matchingrapporttype) {

    $scope.userService = userService;
    $scope.p2c = p2cService.model;

    $scope.testafnames = [];
    $scope.matchingrapporttypes = [];
    $scope.rapport_type = 1;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        Matchingrapporttype.all().then(function(matchingrapporttypes) {
           $scope.matchingrapporttypes = matchingrapporttypes;
        });

        params = {
            _method: 'get_resultaten_testafnames',
            matching_session_id: p2cService.model.matching_session_id
        };
        angular.forEach(p2cService.model.competentieprofielen, function(competentieprofiel) {
            angular.forEach(competentieprofiel.competentietypes, function(competentietype) {
                angular.forEach(competentietype.competenties, function(competentie) {
                    params["ideaalscores["+competentieprofiel.id+"]["+competentie.id+"][min]"] = competentie.min_ideaalscore_aangepast;
                    params["ideaalscores["+competentieprofiel.id+"]["+competentie.id+"][max]"] = competentie.max_ideaalscore_aangepast;
                });
            });
        });
        Ajax.post('matching', params).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.testafnames = response.data.testafnames;
            }
        });
    };
    $scope.refresh = refresh;

    $scope.downloadRapport = function(ev) {
        $mdDialog.show({
            controller: DownloadRapportDialogController,
            locals: {
                rapport_type: $scope.rapport_type
            },
            templateUrl: '/matching/download-rapport',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    function DownloadRapportDialogController($scope, $mdDialog, p2cService, rapport_type) {
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';

        var params = {
            _method: 'genereer_rapport_testafnames',
            matching_session_id: p2cService.model.matching_session_id,
            rapport_type: rapport_type,
        };

        Ajax.post('matching', params).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });
    };


});